import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {/*NotificationsStatusType,*/ INotificationAction, INotificationState} from "dataModels/stateModels/notification";

const defaultState:INotificationState = {
    show:false
}
export const NotificationSlice = createSlice(
    {
        name: "notifications",
        initialState:defaultState,
        reducers:{
            hideNotification:(state:INotificationState)=>{
                state.show = false;
                state.status = undefined;
                state.title = undefined;
                state.description = undefined;
                state.onClose = undefined;
            },
            showNotification:(state:INotificationState, action:PayloadAction<INotificationAction>)=>{
                state.show = true;
                state.status = action.payload.status;
                state.title = action.payload.title;
                state.description = action.payload.description;
                state.onClose = action.payload.onClose;
            }
        }
    }
);

export const {showNotification, hideNotification} = NotificationSlice.actions;
export default NotificationSlice.reducer;